import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, shareReplay } from 'rxjs';
import { ApiService } from './api.service';
import { RolePermissions } from '@app/shared/models/user';
import * as moment from 'moment';

@Injectable({
  providedIn: 'root',
})
export class RoleService extends ApiService {
  private roles$?: Observable<Role[]>;
  constructor(public http: HttpClient) {
    super(http);
  }

  baseUri = 'socrates/authz/api/roles';

  public getAll(): Observable<any> {
    if (!this.roles$) {
      this.roles$ = this.http.get<Role[]>(this.endpoint(this.baseUri)).pipe(shareReplay({ bufferSize: 1, refCount: true }));
    }
    return this.roles$;
  }

  public getById(id: string): Observable<any> {
    return this.http.get<Role[]>(this.endpoint(this.baseUri, id));
  }

  public postRolePermissionExterneApp(permissionId: string, roleId: string, userGuid: string): Observable<RolePermissions> {
    const payload = {
      roleId: roleId,
      permissionId: permissionId,
      modifyUser: userGuid,
      modifydate: moment.utc().toDate(),
    };
    return this.http.post<RolePermissions>(this.endpoint(this.baseUri, `${roleId}/permissions/${permissionId}`), payload);
  }
}

export interface Role {
  guid: string;
  name: string;
  code: string;
  roleLevel: number;
  isActive: boolean;
  rootNodeRegionTypeId: string;
  selectableNodeRegionTypeId: string;
  managedRoles: string;
  idpname: string;
}
